<template>
  <IQOS :title="$t('integrations.poster_settings.title')" required enabled v-if="all_spots && all_spots.length > 1">
      <div class="mt-16" v-if="!busy">
        <BaseSelect :disabled="!editing" fullWidth class="w-100 tablet-select" :readonly="!editing" v-model="spot_id">
            <option :value="null" disabled> {{$t('integrations.poster_settings.choose_spot')}}  </option>
            <option 
                v-for="(spot,index) in all_spots" 
                :key="index" 
                :value="spot.spot_id">
                {{ spot.spot_name }} {{ spot.spot_adress ? `(${spot.spot_adress})` : ''}}
                </option>
        </BaseSelect>
        <p class="qrw-paragraph-md iqos-comment mt-16">
          {{$t('integrations.poster_settings.choose_poster_spot')}}
        </p>
      </div>

      <DangerConfirmModal 
        @confirm="confirmPriceUpdates"
        @cancel="update_price_modal = false"
        v-if="update_price_modal">
        {{ $t('integrations.poster_settings.update_prices_request') }}
      </DangerConfirmModal>

    <template #actions>
      <IQOSActions 
        :editing="editing"
        @edit="showEditUI"
        @cancel="hideEditUI"
        @accept="onEditFinish"/>
    </template>
  </IQOS>
</template>

<script>
import PosterAPI from '@/api/poster'

export default {
    data() {
        return {
            editing: false,
            busy: true,

            spot_id: null,

            update_price_modal: false,

            all_spots: [],

            uses_multiprice: false
        }
    },
    methods: {
        fetchData() {
            PosterAPI.getSpots(this.cafe._id).then(data => {
                this.all_spots = data.spots;
                this.busy = false;

                this.resetValue();
            }).catch(error => {
                this.$store.dispatch('showError', 'poster_error');
            });

            PosterAPI.getGeneralSettings(this.cafe._id).then(data => {
                this.uses_multiprice = data.settings.uses_multiprice == '1';
            }).catch(error => {

            });
        },  
        confirmPriceUpdates() {
            this.update_price_modal = false;

            PosterAPI.resyncAllPrices(this.cafe._id).then(data => {
                
            }).catch(error => {
                this.$store.dispatch('showError', 'poster_error');
            });
        },
        showEditUI() {
            this.editing = true;
        },
        hideEditUI() {
            this.editing = false;
            this.resetValue();
        },
        onEditFinish() {
            const old_value = this.cafe.poster.spot_id;

            this.$store.commit('setPosterSetting', {
                key: 'spot_id',
                value: this.spot_id
            });
            this.$store.dispatch('saveCafe');
            this.editing = false;

            if (this.spot_id != old_value && this.uses_multiprice)  {
                this.update_price_modal = true;
            }
        },
        resetValue() {
            if (this.cafe.poster) {
                this.spot_id = this.cafe.poster.spot_id;
            }
        }
    },
    mounted() {
        this.fetchData();
    },
    computed: {
        cafe() {
            return this.$store.state.cafe;
        }
    }
}
</script>

<style scoped>
.tablet-select {
    width: 100% !important;

    text-align-last: center;
    text-align: center;
}
</style>